import React, { useContext, useEffect, useState } from "react";
import { RiDeleteBinLine } from "react-icons/ri";
import AuthUser from "../AuthUser";

import Drawer from "./Drawer";
import { toast } from "react-toastify";
import RightSidebar from "../Common/RightSidebar";
import "../../CSS/Layout.css";
import Select from "react-select";
import moment from "moment";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { useQuery } from "react-query";
import Camera from "./Camera";
import { cashierLang } from "../language/pages/cashierPageLang";
import useLanguage from "../language/useLanguage";
import CashierNavbar from "../Common/CashierNavbar";
import ReactDatePicker from "react-datepicker";
import { appContext } from "../../navbar/auth";
import { useLocation } from "react-router-dom";

const CashierPerson = () => {
  const { http, user } = AuthUser();
  const lan = useLanguage(cashierLang);
  const alertToast = (text) => toast.error(text);
  const { data } = useQuery("current-stock", () =>
    http.get(`/current-stock-sales-counter`).then((res) => res?.data)
  );
  const [billType, setBillType] = useState("customer");
  const { data: customers } = useQuery(billType, () =>
    http.get(`/customers/${billType}`).then((res) => res?.data?.data)
  );
  const { pathname } = useLocation();
  const {
    cart,
    setCart,
    setAllSubTotal,
    setAllSubTotalWithoutDiscount,
    setInvoice,
    setStickerCart,
    invoiceReload,
    setInvoiceReload,
    invoiceId,
    setInvoiceId,
    setPaymentMethod,
    setSpecialDiscount,
    setReturnAmount,
    updateTrack,
    setInvoicePaidUnpaid,
    paymentStatus,
    setPaymentStatus,
    autoReloadInvoice,
    setPrescriptionImage,
    setPaidAmount,
    setSelectedInvoice,
  } = useContext(appContext);

  useEffect(() => {
    http.get(`/last-invoice`).then(async (res) => {
      if (res?.data?.data) {
        const rendomNumber = `INV-${res.data.data?.id + 10001}`;
        setInvoice(rendomNumber);

        setPaidAmount();
      } else {
        setInvoice("INV-10001");
        setPaidAmount();
      }
    });
  }, [invoiceReload]);

  // End of Select with check box for printing stickers
  const [invoiceData, setInvoiceData] = useState({
    customer_type: billType,
    date: new Date(),
    delivery_charge: "",
    last_due: "",
    last_due_date: "",
    member_id: "",
    receiver_name: "",
    receiver_address: "",
    previous_due: "",
    previous_due_date: "",
    transport: "",
    due: "",
  });
  const boxQtyHandler = (item, e) => {
    const existCart = [...cart];
    existCart.map((pd) => {
      if (pd.id === item.id) {
        const temp = e.target.value;
        if (!temp) {
          pd.noOfBox = 0;
          pd.pcs = "";
          pd.totalPrice = 0;
          pd.totalPriceWithoutDiscount = 0;
        } else {
          if (parseFloat(temp) <= item.stock || parseFloat(temp) <= item.qty) {
            const test = parseFloat(temp / parseFloat(item.pktSize));
            // console.log("Calculated data",test);
            pd.noOfBox = test;
            pd.pcs = parseFloat(temp);
            pd.totalPrice = parseFloat(pd?.price || 0) * parseFloat(pd.pcs);
            pd.totalPriceWithoutDiscount =
              parseFloat(pd?.price || 0) * parseFloat(pd.pcs);
          } else {
            alertToast(
              `Not available more than ${item.stock ? item.stock : item.qty}`
            );
          }
        }
      }
    });
    setCart(existCart);
  };
  const priceHandler = (item, e) => {
    const existCart = [...cart];
    existCart.map((pd) => {
      if (pd.id === item.id) {
        const temp = e.target.value;
        if (!temp) {
          pd.price = "";
          pd.totalPrice = 0;
          pd.totalPriceWithoutDiscount = 0;
        } else {
          pd.price = parseFloat(temp);
          pd.totalPrice = parseFloat(pd?.price || 0) * parseFloat(pd.pcs || 0);
          pd.totalPriceWithoutDiscount =
            parseFloat(pd?.price || 0) * parseFloat(pd.pcs || 0);
        }
      }
    });
    setCart(existCart);
  };
  useEffect(() => {
    if (cart.length > 0) {
      const subTotal = cart.reduce(
        (previousValue, currentValue) =>
          previousValue + parseFloat(currentValue.totalPrice),
        0
      );
      const subTotalNoDisc = cart.reduce(
        (previousValue, currentValue) =>
          previousValue + parseFloat(currentValue.totalPrice),
        0
      );
      const subWithDelivery =
        subTotal + parseFloat(invoiceData?.delivery_charge || 0);
      const subNoDisc =
        subTotalNoDisc + parseFloat(invoiceData?.delivery_charge || 0);
      setAllSubTotal(parseFloat(subWithDelivery).toFixed(2));
      setAllSubTotalWithoutDiscount(parseFloat(subNoDisc).toFixed(2));
      setStickerCart(cart);
    }
  }, [cart, invoiceData?.delivery_charge]);

  // Getting All invoices
  const [allInvoices, setAllInvoices] = useState([]);
  const [paidInvoices, setPaidInvoices] = useState([]);
  const [unPaidInvoices, setUnPaidInvoices] = useState([]);

  useEffect(() => {
    http.get("invoice").then((res) => {
      setAllInvoices(res.data.data);
      setInvoicePaidUnpaid(res.data.data);

      setPaidInvoices(
        res.data.data.filter((item) => item.payment_status === "Paid")
      );
      setUnPaidInvoices(
        res.data.data.filter((item) => item.payment_status === "Unpaid")
      );
    });
  }, [updateTrack, autoReloadInvoice]);

  const handleIVInput = (e) => {
    // setPurchaseOrderId(e.id);
    setInvoiceId(e.id);
  };
  // End of getting All invoices
  const [pImage, setPImage] = useState("");
  // get selected invoice
  useEffect(() => {
    if (invoiceId !== null) {
      http.get(`view-selected-invoice/${invoiceId}`).then((res) => {
        if (res.data.status === 200) {
          setSelectedInvoice(res.data.data);
          setPaymentMethod(res.data?.data?.discount_type);
          setAllSubTotalWithoutDiscount(res.data?.data?.sub_total);
          //set paid unpaid status
          setPaymentStatus(res.data.data.payment_status);
          setCart(res.data.invoice_details);
          setInvoice(res.data.data.invoice_no);
          setPImage(res.data.data.prescription_image);
          setSpecialDiscount(res.data.data.special_discount);
        } else {
          // setError(res.data.errors);
        }
      });
    }
  }, [invoiceId]);

  // end of select invoice
  const removeMedicine = (item) => {
    const existCart = [...cart];
    const newCart = existCart.filter((pd) => pd.id !== item.id);
    setCart(newCart);
  };

  //   Clear all information
  const [searchMedicine, setSearchMedicine] = useState("");
  const clearInfo = () => {
    setCart([]);
    setInvoiceReload(!invoiceReload);
    //
    setInvoiceId();
    setSpecialDiscount(0);
    setReturnAmount(0);
    setPaymentMethod("Cash");
    setPaymentStatus("Default");
    setPImage("");
    setSearchMedicine("");
    setSelectedInvoice({});
    setInvoiceData({
      customer_type: "customer",
      date: new Date(),
      delivery_charge: "",
      last_due: "",
      last_due_date: "",
      member_id: "",
      receiver_name: "",
      receiver_address: "",
      previous_due: "",
      previous_due_date: "",
      transport: "",
      due: "",
    });
  };

  const formatResult = (item) => {
    return (
      <>
        <div
          className={`row d-flex align-items-center search-format ${
            item.stock < 1 && Number(item?.is_stockable) === 1
              ? "bg-red text-white"
              : ""
          } `}
        >
          <div className="col-9">
            <p>{item?.drug?.macrohealth_sg}</p>
            {/* <p className="ms-2">{item?.drug?.generic_name}</p> */}
          </div>
          {/* <div className="col-3">
            <p>{item?.drug?.manufacturer}</p>
          </div> */}
          {/* <div className="col-2">
            <p>{item.drug?.price} tk</p>
          </div> */}
          <div className="col-3 ">
            <div className="row">
              <div className="col-7">
                <p>{Number(item?.is_stockable) === 1 ? item?.stock : ""}</p>
              </div>
              <div className="col-3">
                <i
                  style={{ fontSize: "12px" }}
                  className={`fas fa-circle ${
                    item.stock < 1 && Number(item?.is_stockable) === 1
                      ? "text-danger"
                      : Number(item?.is_stockable) === 0
                      ? "text-warning"
                      : "text-success"
                  }`}
                ></i>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const medicineSelect = (item) => {
    if (item.stock < 1) {
      toast.error("This product is out of stock");
      return;
    } else {
      let alreadyExist = false;
      const newCart = [...cart];

      newCart.map((pd) => {
        if (pd.id === item.id) {
          alreadyExist = true;
        }
      });

      if (!alreadyExist) {
        newCart.push({
          ...item,
          noOfBox: 0,
          pcs: "",
          pktSize: item.drug.pktSize,
          boxType: item.drug.boxType,
          expire_date: item.drug.expiry_date,
          totalPrice: 0,
          price: "",
          totalPriceWithoutDiscount: 0,
        });
      }
      setCart(newCart);
      setSearchMedicine("");
    }
  };
  const imageURL = global.img_Url;
  const prescriptionImage = document.getElementById("prescription-image");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInvoiceData({
      ...invoiceData,
      [name]: value,
    });
  };
  console.log("invoiceData", invoiceData);
  return (
    <>
      <div style={{ minHeight: "90dvh" }} className={`container-fluid`}>
        <CashierNavbar />
        <div style={{ marginTop: "70px" }}>
          <div className="row mb-2">
            <div className="col-8">
              <div className="custom-card p-1">
                <div className="row">
                  <div className="col-3">
                    <label className="invoice-label"> Date</label>
                    <ReactDatePicker
                      className="form-control form-control-sm"
                      selected={
                        invoiceData?.date ? invoiceData?.date : new Date()
                      }
                      dateFormat="dd/MM/yyyy"
                      onChange={(date) => {
                        setInvoiceData({
                          ...invoiceData,
                          date: date,
                        });
                      }}
                    />
                  </div>
                  <div className="col-3">
                    <label className="invoice-label"> Bill Type</label>
                    <Select
                      options={[
                        { value: "customer", label: "Customer" },
                        { value: "dealer", label: "Dealer" },
                      ]}
                      placeholder={lan?.select}
                      onChange={(e) => {
                        setBillType(e.value);
                      }}
                      value={{
                        value: billType,
                        label: billType === "customer" ? "Customer" : "Dealer",
                      }}
                    />
                  </div>
                  <div className="col-6">
                    <label className="invoice-label">
                      {" "}
                      Select {billType === "customer" ? "Customer" : "Dealer"}
                    </label>

                    <div className="">
                      <Select
                        options={customers}
                        placeholder={lan?.select}
                        onChange={(e) =>
                          setInvoiceData({
                            ...invoiceData,
                            member_id: e.id,
                            name: e.member_name,
                            address: e.address,
                            mobile: e.mobile,
                            due: parseFloat(e?.due || 0),
                            last_due: e?.last_invoice?.present_due || 0,
                            last_due_date: e?.last_invoice?.date
                              ? moment(e?.last_invoice?.date).format(
                                  "DD/MM/YYYY"
                                )
                              : "",
                          })
                        }
                        getOptionLabel={(unPaidInvoices) =>
                          `${unPaidInvoices.member_name}`
                        }
                        getOptionValue={(unPaidInvoices) =>
                          `${unPaidInvoices.id}`
                        }
                        value={customers?.filter(
                          (unPaidInvoices) =>
                            unPaidInvoices.id === invoiceData?.member_id
                        )}
                      />
                    </div>
                  </div>
                </div>
                {/* search box  */}
                <div className="search-container pb-2 row mt-2">
                  <div className="search-box-container col-md-9 ">
                    {/* </div> */}
                    <ReactSearchAutocomplete
                      showIcon={false}
                      placeholder={lan?.searchProducts}
                      inputSearchString={searchMedicine || ""}
                      onSearch={(value) => setSearchMedicine(value)}
                      items={data}
                      resultStringKeyName="name"
                      maxResults={5}
                      onSelect={(item) => medicineSelect(item)}
                      autoFocus
                      fuseOptions={{ keys: ["name"] }} // Search in the description text as well
                      styling={{
                        borderRadius: "5px !important",
                        // zIndex: user?.user_type === "cashier" ? 0 : 0,
                        minHeight: "36px",
                        position: "static",
                        height: "36px",
                        fontSize: "13px",
                      }}
                      formatResult={formatResult}
                    />
                  </div>

                  <div className="col-md-3 col-sm-12 d-flex search-invoice-section">
                    <div>
                      <button
                        className="btn btn-primary btn-sm rounded px-2 mt-1"
                        onClick={clearInfo}
                      >
                        {lan?.clear}
                      </button>
                    </div>
                    {/* <h6 className="mx-sm-2 text-xs mt-sm-2  mx-md-3 mt-1 whitespace-nowrap lg:text-[14px]">
                      {lan?.invoiceNo} : {cart.length > 0 && invoice}
                    </h6> */}
                    {(user?.user_type === "cashier" ||
                      user?.user_type === "admin" ||
                      user?.user_type === "manager") && (
                      <Drawer
                        allInvoices={allInvoices}
                        paidInvoices={paidInvoices}
                        unPaidInvoices={unPaidInvoices}
                      />
                    )}
                  </div>
                </div>
                {/* prescription upload  */}
                <div className="prescription-upload pb-1 mt-2">
                  <div className="row">
                    <div className={`col-12`}>
                      <div className="row">
                        <div className="col-2 text-start">
                          <p className="mt-1 mb-0 text-lg fw-bold lg:text-[14px] whitespace-nowrap ms-1 ">
                            {lan?.documentUpload}
                          </p>
                        </div>
                        <div className="col-4">
                          <input
                            onChange={(e) =>
                              setPrescriptionImage(e.target.files[0])
                            }
                            type="file"
                            accept="image/*"
                            id="prescription-image"
                            className="form-control form-control-sm ms-1"
                          />
                        </div>
                        <div className="col-1">
                          {/* <FaCamera color='#69B128' size={20} /> */}
                          <Camera setPrescriptionImage={setPrescriptionImage} />
                        </div>
                        {/* <div className="col-5 d-flex">
                          {user.user_type === "cashier" && (
                            <div className="w-50">
                              <Select
                                options={unPaidInvoices}
                                placeholder={lan?.select}
                                onChange={handleIVInput}
                                getOptionLabel={(unPaidInvoices) =>
                                  `${unPaidInvoices.invoice_no}`
                                }
                                getOptionValue={(unPaidInvoices) =>
                                  `${unPaidInvoices.invoice_no}`
                                }
                              />
                            </div>
                          )}
                          {invoiceId && (
                            <p
                              style={{ background: "#e4f1a3" }}
                              className="px-3 py-1 ms-1 rounded-pill fw-bold"
                            >
                              {paymentStatus}
                            </p>
                          )}
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>

                {/* medicine cart  */}

                <>
                  <div
                    style={{ marginLeft: ".85rem", marginRight: ".85rem" }}
                    className="cart-container mt-2"
                  >
                    <div className="row">
                      <table className="cart-table">
                        <tr className="cart-table-head">
                          <td width={"40%"}>{lan?.productName}</td>
                          {/* <td>{lan?.expDate}</td>
                    <td>{lan?.boxType}</td>
                    <td> {lan?.size}</td> */}
                          {/* <td width={"6%"}>{lan?.boxLeaf}</td> */}
                          <td className="text-center">{lan?.unit}</td>
                          <td width={"6%"}>{lan?.quantity}</td>
                          {/* <td className="text-center">{lan?.discount}</td> */}
                          <td>{lan?.price}</td>
                          <td>{lan?.total}</td>
                          <td width={"8%"}>{lan?.action}</td>
                        </tr>
                        {invoiceId ? (
                          <>
                            {cart.length > 0 &&
                              cart.map((item, i) => (
                                <tr
                                  key={i}
                                  className="border-bottom cart-table-body"
                                >
                                  <td width={"25%"}>{item.name}</td>
                                  <td style={{ textAlign: "center" }}>
                                    {item?.unit}
                                  </td>
                                  <td>{item.pcs}</td>
                                  <td>{parseFloat(item?.price).toFixed(2)}</td>
                                  <td width={"8%"}>
                                    {parseFloat(item?.totalPrice).toFixed(2)}
                                  </td>
                                  {paymentStatus !== "Paid" && (
                                    <td className="text-center">
                                      <RiDeleteBinLine
                                        // onClick={() => removeMedicine(item)}
                                        aria-disabled
                                        style={{
                                          fontSize: "16px",
                                          marginRight: "4px",
                                          cursor: "pointer",
                                        }}
                                        title="Delete Item"
                                      />
                                    </td>
                                  )}
                                </tr>
                              ))}
                          </>
                        ) : (
                          <>
                            {cart?.length > 0 &&
                              cart?.map((item, i) => (
                                <tr
                                  key={i}
                                  className="border-bottom cart-table-body"
                                >
                                  <td width={"25%"}>
                                    {item?.drug?.macrohealth_sg}
                                  </td>

                                  <td style={{ textAlign: "center" }}>
                                    {item?.drug?.unit}
                                  </td>

                                  {paymentStatus !== "Paid" ? (
                                    <td>
                                      <div style={{ width: "100px" }}>
                                        <input
                                          value={item?.pcs}
                                          onChange={(e) =>
                                            boxQtyHandler(item, e)
                                          }
                                          className="form-control form-control-sm"
                                          type="number"
                                        />
                                      </div>
                                    </td>
                                  ) : (
                                    <td>{item?.pcs}</td>
                                  )}

                                  {/* <td style={{ textAlign: "center" }}>0 %</td> */}

                                  {/* <td>
                                    {item.drug
                                      ? Number(item?.drug?.price).toFixed(2)
                                      : Number(item?.price).toFixed(2)}
                                  </td> */}
                                  <td>
                                    <div style={{ width: "100px" }}>
                                      <input
                                        value={item?.price}
                                        onChange={(e) => priceHandler(item, e)}
                                        className="form-control form-control-sm"
                                        type="number"
                                      />
                                    </div>
                                  </td>
                                  <td width={"8%"}>
                                    {/* <input type="text" value={item.cash_drug_discount ? ((item.price * item.pcs) - ((item.price * item.drug_discount * item.pcs) / 100)) : (item.price * item.pcs)} className="form-control form-control-sm" /> */}
                                    {Number(item?.totalPrice).toFixed(2)}
                                  </td>

                                  <td>
                                    <RiDeleteBinLine
                                      onClick={() => removeMedicine(item)}
                                      style={{
                                        fontSize: "16px",
                                        marginRight: "4px",
                                        cursor: "pointer",
                                      }}
                                      title="Delete Item"
                                    />
                                  </td>
                                </tr>
                              ))}
                          </>
                        )}
                      </table>
                    </div>
                  </div>
                </>

                {/* uploaded image  */}
                {pImage && pImage !== "null" && (
                  <div className="custom-card m-3 p-3">
                    <h3 className="text-center"> Prescription </h3>
                    {pImage?.endsWith(".jpg") ||
                    pImage?.endsWith(".png") ||
                    pImage?.endsWith(".jpeg") ||
                    pImage?.endsWith(".webp") ||
                    pImage?.endsWith(".gif") ? (
                      <img
                        src={`${imageURL}/images/files/${pImage}`}
                        className="prescription-img"
                        alt="prescription"
                      />
                    ) : (
                      <img
                        src={pImage}
                        className="prescription-img"
                        alt="prescription"
                      />
                    )}
                  </div>
                )}

                <RightSidebar
                  pImage={prescriptionImage}
                  setSearchMedicine={setSearchMedicine}
                  setPImage={setPImage}
                  invoiceData={invoiceData}
                  setInvoiceData={setInvoiceData}
                />
              </div>
            </div>
            <div className="col-4">
              <div className="custom-card p-2">
                {pathname === "/cashier" && (
                  <div className="d-flex">
                    <div className="me-1" style={{ width: "30%" }}>
                      <label className="invoice-label"> Total Due</label>
                      <input
                        className="form-control form-control-sm"
                        value={invoiceData?.due}
                        readOnly
                      />
                    </div>
                    <div className="me-1" style={{ width: "30%" }}>
                      <label className="invoice-label"> Last Dues Date</label>
                      <input
                        className="form-control form-control-sm"
                        // onChange={handleChange}
                        name="last_dues_date"
                        value={invoiceData?.last_due_date}
                        readOnly
                      />
                    </div>
                    <div className="" style={{ width: "40%" }}>
                      <label className="invoice-label">Last Dues Amount</label>
                      <input
                        className="form-control form-control-sm"
                        // onChange={handleChange}
                        name="last_dues_amount"
                        value={invoiceData?.last_due}
                        readOnly
                      />
                    </div>
                  </div>
                )}

                <div className="row mb-2">
                  {pathname !== "/cashier" && (
                    <>
                      <div className="col-4">
                        <label className="invoice-label"> Total Due</label>
                        <input
                          className="form-control form-control-sm"
                          value={invoiceData?.due}
                          readOnly
                        />
                      </div>
                      <div className="col-4">
                        <label className="invoice-label"> Last Dues Date</label>
                        <input
                          className="form-control form-control-sm"
                          // onChange={handleChange}
                          name="last_dues_date"
                          value={invoiceData?.last_due_date}
                          readOnly
                        />
                      </div>
                      <div className="col-4">
                        <label className="invoice-label">
                          Last Dues Amount
                        </label>
                        <input
                          className="form-control form-control-sm"
                          // onChange={handleChange}
                          name="last_dues_amount"
                          value={invoiceData?.last_due}
                          readOnly
                        />
                      </div>
                    </>
                  )}
                  <div className="col-6">
                    <label className="invoice-label"> Receiver Name</label>
                    <input
                      className="form-control form-control-sm"
                      onChange={handleChange}
                      name="receiver_name"
                      value={invoiceData?.receiver_name || ""}
                    />
                  </div>
                  <div className="col-6">
                    <label className="invoice-label"> Receiver Address</label>
                    <input
                      className="form-control form-control-sm"
                      onChange={handleChange}
                      name="receiver_address"
                      value={invoiceData?.receiver_address || ""}
                    />
                  </div>
                  <div className="col-6">
                    <label className="invoice-label"> Previous Due Date</label>
                    <ReactDatePicker
                      className="form-control form-control-sm"
                      selected={
                        invoiceData?.previous_due_date
                          ? invoiceData?.previous_due_date
                          : ""
                      }
                      dateFormat="dd/MM/yyyy"
                      onChange={(date) => {
                        setInvoiceData({
                          ...invoiceData,
                          previous_due_date: date,
                        });
                      }}
                      placeholderText="DD/MM/YYYY"
                    />
                  </div>
                  <div className="col-6">
                    <label className="invoice-label">
                      {" "}
                      Previous Due Amount
                    </label>
                    <input
                      className="form-control form-control-sm"
                      onChange={handleChange}
                      name="previous_due"
                      value={invoiceData?.previous_due || ""}
                    />
                  </div>
                  {/* <div className="col-6">
                    <label className="invoice-label"> Delivery Charge</label>
                    <input
                      className="form-control form-control-sm"
                      onChange={handleChange}
                      name="delivery_charge"
                    />
                  </div> */}

                  <div className="col-6">
                    <label className="invoice-label">Transport</label>
                    <input
                      className="form-control form-control-sm"
                      onChange={handleChange}
                      name="transport"
                      value={invoiceData?.transport || ""}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CashierPerson;
